import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              1. Vardhan K., Kumar P. and Panda R., 2019, Journal of Molecular
              Liquids, 290.
              <br />
              2. Khulbe C. and Matsuura T., 2018, Removal of heavy metals and
              pollutants by membrane adsorption techniques. Applied Water
              Science, 8, 19.
              <br />
              3. Azubuike C., Chikere B. and Okpokwasili C., 2016, World Journal
              of Microbiology and Biotechnology, 32, 180.
              <br />
              4. Pande V., Pandey C., Sati D., Pande V. and Samant M., 2020,
              Environmental Sustainability, 3, 91-103. <br />
              5. Etim E., 2012, International Journal of Environment and
              Bioenergy, 2, 120-136.
              <br />
              6. Lee H., 2013, Biotechnology and Bioprocess Engineering, 18,
              431-439.
              <br />
              7. Wei Z., Van Le Q., Peng W., Yang Y., Yang H., Gu H., Lam S. and
              Sonne C., 2021, Journal of Hazardous Materials, 403. <br />
              8. Gupta P., Roy S. and Mahindrakar A., 2012, Resources and
              Environment, 2, 202-215.
              <br />
              9. Kochi L., Freitas P., Maranho L., Juneau P. and Gomes M., 2020,
              Sustainability, 12, 9202.
              <br />
              10. Galal M. and Farahat A., 2015, Environmental Monitoring and
              Assessment, 187, 701.
              <br />
              11. Guo-feng L., Zhang lu., Cheng-xin F., Shi-qun H., Jun H. and
              Paerl H., 2014, Journal of Pollution Effects and Control, 2, 113.{" "}
              <br />
              12. Maddison M., Mauring T., Remm K., Lesta M. and Mander U.,
              2009, Ecological Engineering, 35, 258-264.
              <br />
              13. Jha P., Samal A., Santra S. and Dewanji A., 2016, American
              Journal of Plant Sciences, 7, 2112-2137.
              <br />
              14. Herath I. and Vithanage M., 2015, Phytoremediation in
              constructed wetlands. In: Phytoremediation: Management of
              environmental contaminants, Ansari A., Gill S., Gill R., Lanza R.
              and Newman L (eds), vol 2, Springer International Publishing
              Switzerland.
              <br />
              15. Gallon C., Munger C., Premont S. and Campbell P., 2004, Water,
              Air, & Soil Pollution, 153, 135-155.
              <br />
              16. Kamal M., Ghaly A., Mahmoud N. and Cote R., 2004, Environment
              International, 29, 1029-1039.
              <br />
              17. Hou W., Chen X., Song G., Wang Q. and Chang C., 2007, Plant
              Physiology and Biochemistry, 45, 62-69.
              <br />
              18. Cook C., 1996, Aquatic and wetland plants of India, Oxford New
              York, Oxford University Press.
              <br />
              19. APHA, 1995, Standard Methods for the examination of water and
              wastewater, 19th ed., American Public Health Association,
              Washington, DC.
              <br />
              20. Arguello J., Raimunda D. and Padilla-Benavides T., 2013,
              Frontiers in Cellular and Infection Microbiology, 3, 1-14.
              <br />
              21. Nas F. and Ali M., 2018, MOJ Ecology and Environmental
              Sciences, 3, 265-268.
              <br />
              22. Gill M., 2014, International Journal of Advanced Research, 2,
              1043-1055.
              <br />
              23. Singh S., Parihar P., Singh R., Singh V. and Prasad S., 2016,
              Frontiers in Plant Science, 6, 1-36.
              <br />
              24. Maiti S.K., 2003, Handbook of emthods in environmental
              studies: Air, noise, soil and overburden analysis, vol 2, ABD pub,
              Oxford Book Co, India.
              <br />
              25. MacDonald D., Ingersoll C. and Berger A., 2000, Archives of
              Environmental Contamination Toxicology, 39, 20-31.
              <br />
              26. Istenic D., Arias C. and Brix H., 2011, The Proceedings
              Strepow Workshop, Andrevlje- Novi Sad, Serbia, p.111-117. <br />
              27. Tiwari S., Dixit S. and Verma N., 2007, Environmental
              Monitoring Assessment, 129, 253- 256.
              <br />
              28. Marbaniang D. and Chaturvedi S., 2014, Keanean Journal of
              Science, 2, 29-34.
              <br />
              29. Chandra R. and Yadav S., 2010, Ecological Engineering, 36,
              1277-1284.
              <br />
              30.Ensley D., 2000, Rational for use of phytoremediation. In:
              Phytoremediation of toxic metals: Using plants to clean- up the
              environment, Raskin I. and Ensley D (eds), New York, John Wiley &
              Sons, Inc, p.3-12.
              <br />
              31. Akbarzadeh A., Jamshidi S. and Vakhshouri M., 2015, Pollution,
              1, 1-8.
              <br />
              32. Perez-Sirvent C., Hernandez-Perez C., Martinez-Sánchez M.,
              Lorenzo M. and Bech J., 2017, Journal of Soils and Sediments, 17,
              1384-1393.
              <br />
              33. Schuck M. and Greger M., 2020, International Journal of
              Environment Research and Public Health, 17, 4623.
              <br />
              34. Wu H., Zhang J., Ngo H., Guo W., Hu Z., Liang S., Fan J. and
              Liu H., 2015, Bioresource Technology, 175, 594-601.
              <br />
              35. Ramachandra T., Sudarshan B., Mahesh K. and Vinay S., 2018,
              Journal of Environmental Management, 206, 1204-1210.
              <br />
              36. Sudarshan B., Mahesh M. and Ramachandra T., 2019, Indian
              Journal of Environmental Protection, 39, 594-601.
              <br />
              37. Ramachandra T.V., Sudarshan B., Shivamurthy V., Asulabha S.
              and Varghese S., 2020, SN Applied Sciences, 2, 3228-3238.
              <br />
              38. Bharath H. Aithal and Ramachandra T. V., 2016, J Indian Soc
              Remote Sens, 44(4):617-633 <br />
              39. Ahalya, N., Kanamadi R.D. and Ramachandra T.V., 2007, Journal
              of Enviro Bio, 28(4): 765-769
              <br />
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
